import React, { useEffect, useState } from 'react';
import { Box, Button, Card, IconButton, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CancelIcon from '@mui/icons-material/Cancel';

function ImageUpload({
  currentImages = [], // array of strings or objects { image: string }
  onImagesChange,
  clearImages,
  isEditing,
  allowMultiple,
  folder = process.env.REACT_APP_IMAGE_PATH_PRODUCTS,
}) {
  // items: { file: File|null, image: string }
  const [items, setItems] = useState([]);

  // Initialize with existing images on edit
  useEffect(() => {
    if (isEditing && currentImages && currentImages.length > 0) {
      const initial = currentImages.map((img) => {
        const url = typeof img === 'string' ? img : img.image;
        return { file: null, image: url };
      });
      setItems(initial);
      onImagesChange?.(initial);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditing, currentImages]);

  // Clear images when requested by parent
  useEffect(() => {
    if (clearImages) {
      setItems([]);
      onImagesChange?.([]);
    }
  }, [clearImages, onImagesChange]);

  const handleFileUpload = (e) => {
    const selectedFiles = Array.from(e.target.files || []);

    const newItems = selectedFiles.map((file) => ({
      file,
      image: URL.createObjectURL(file),
    }));

    const merged = allowMultiple
      ? [...items, ...newItems]
      : newItems[0]
        ? [newItems[0]]
        : [];
    setItems(merged);
    onImagesChange?.(merged);
  };

  const removeAt = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
    onImagesChange?.(updated);
  };

  return (
    <Box sx={{ border: '2px dashed gray', p: 2, width: '100%' }}>
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{ mb: 2 }}
      >
        <Typography variant='h6'>Choose files here</Typography>
        <Button
          variant='contained'
          component='label'
          startIcon={<CloudUploadIcon />}
        >
          Upload
          <input
            hidden
            type='file'
            multiple={allowMultiple}
            accept='image/*'
            onChange={handleFileUpload}
          />
        </Button>
      </Box>

      <Box
        display='flex'
        gap={2}
        flexWrap='wrap'
      >
        {items.map((it, index) => {
          const name =
            it.file?.name ||
            (typeof it.image === 'string'
              ? it.image.split('/').pop()
              : 'image');
          const sizeKb = it.file?.size ? Math.round(it.file.size / 1024) : null;
          return (
            <Card
              key={index}
              sx={{ width: 150, position: 'relative' }}
            >
              <Box sx={{ position: 'absolute', top: 5, right: 5 }}>
                <IconButton
                  size='small'
                  onClick={() => removeAt(index)}
                >
                  <CancelIcon className='text-light' />
                </IconButton>
              </Box>
              <Box p={1}>
                <img
                  src={
                    it.image.startsWith("blob:")
                      ? it.image
                      : it.image.startsWith("http")
                        ? it.image
                        : `${process.env.REACT_APP_API_URL}/assets/images/products/${it.image}`
                  }
                  alt={name}
                  style={{ width: "100%", height: "120px", objectFit: "cover" }}
                />


                <Typography noWrap>{name}</Typography>
                {sizeKb !== null && (
                  <Typography variant='caption'>{sizeKb} KB</Typography>
                )}
              </Box>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
}

export default ImageUpload;
